module.exports = __webpack_public_path__ + "img/dsh2.c764cc1a.jpg";